import type { ReactNode } from "react";
import InfoPopover from "./InfoPopover";

/** Explanations stay one click away instead of standing below every heading (#534). */
export default function SectionInfo({ label, children }: { label: string; children: ReactNode }) {
  return (
    <span className="relative inline-flex">
      <InfoPopover
        ariaLabel={`${label} erklären`}
        triggerClassName="inline-flex h-5 w-5 items-center justify-center rounded-full border border-slate-200 bg-white text-[10px] font-semibold text-slate-500 shadow-sm hover:border-emerald-200 hover:text-emerald-700 focus:outline-none focus:ring-2 focus:ring-emerald-500/30"
        popoverClassName="absolute left-0 top-full z-40 mt-1.5 w-[min(22rem,calc(100vw-3rem))]"
      >
        <div className="rounded-lg border border-slate-200 bg-white px-3 py-2 text-xs font-normal normal-case leading-relaxed tracking-normal text-slate-700 shadow-lg ring-1 ring-slate-100">
          {children}
        </div>
      </InfoPopover>
    </span>
  );
}
